import React from 'react';
import './Navbar.css';
import logo from '../assets/logo.png'; // Adjust the path if it's in public or another directory

const Navbar = ({ walletAddress, connectWallet, setWalletAddress, setErrorMessage }) => {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-logo-title">
          <img src={logo} alt="Logo" className="navbar-logo" />
          <h2 className="navbar-title">NFT AI Minter</h2>
        </div>
        {walletAddress ? (
          <span className="wallet-address">{`${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`}</span>
        ) : (
          <button className="connect-wallet-button" onClick={() => connectWallet(setWalletAddress, setErrorMessage)}>
            Connect Wallet
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
